import Vue from 'vue'
import DownloadRoot from './download/DownloadRoot'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#download-app',
  render: h => h(DownloadRoot)
})



// WEBPACK FOOTER //
// ./src/download-main.js